<template>
  <div class="text-center fill-height d-flex align-center justify-center welcome-background">
    <v-row class="fill-height">
      <v-col cols="12" class="d-flex flex-column align-center justify-center">
        <!-- Mensagens de boas-vindas -->
        <h1 class="display-2 font-weight-bold mb-4" style="color: #000000;">Bem-vindo ao App Gestor</h1>
        <p
          class="subtitle-1 mb-5"
          style="font-size: 1.2rem; color: #333333;"
        >Selecione uma opção no menu lateral para começar.</p>

        <!-- Informações adicionais simplificadas
        <p class="text-body-2 mt-4" style="color: #333333;">
          Desenvolvido por Tabosa Sistema. Para mais informações, visite nosso site em
          <a href="https://www.tabosasistema.com" target="_blank" style="color: #1e88e5;">www.tabosasistema.com</a>.
        </p>-->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Welcome",
};
</script>

<style scoped>
.fill-height {
  min-height: auto; /* Garante que a altura ocupe toda a tela */
}

/* Fundo com imagem para dispositivos móveis */
@media (max-width: 1023px) {
  .welcome-background {
    background-image: url("@/assets/login10.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: scroll;
  }
}

/* Fundo com degradê e texto centralizado para desktop */
@media (min-width: 1024px) {
  .welcome-background {
    background: linear-gradient(
      to bottom right,
      #f5f5f5,
      #cfd8dc
    ); /* Degradê suave para desktop */
  }
}

/* Estilos do texto */
h1,
.subtitle-1,
.text-body-2 {
  color: #000000; /* Cor do texto para preto */
  text-align: center; /* Centraliza o texto */
}

/* Centralização vertical em telas grandes */
.v-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
